import { render, staticRenderFns } from "./score_editor.vue?vue&type=template&id=9c466ece&scoped=true"
import script from "./score_editor.vue?vue&type=script&lang=js"
export * from "./score_editor.vue?vue&type=script&lang=js"
import style0 from "./score_editor.vue?vue&type=style&index=0&id=9c466ece&prod&lang=less"
import style1 from "./score_editor.vue?vue&type=style&index=1&id=9c466ece&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c466ece",
  null
  
)

export default component.exports